export default __webpack_public_path__ + "static/media/os_3.8ff57ed4.mp3";